(function () {
  'use strict';
  const SAFETY = 'safety', IN_CAB = 'in-cab', STABILITY_CONTROL = 'stabilityControl',
      STABILITY_CONTROL_SUB_ITEMS = ['ropBrake', 'ropEngine', 'ycBrake', 'ycEngine'],
      ALERT_CONFIG_KEYS = {rollingStop: 'stopSignViolation', noStop: 'stopSignViolation'},
      ROW_TITLES = {rollingStop: 'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.stopSignViolation.titulo'},
      MANUAL_EVENT_HARDWARE = 'manualEventHardware',
      MEDIA_TYPE = {VIDEO: 'VIDEO', IMAGE: 'IMAGE', NO_MEDIA: 'NO_MEDIA'},
      COMPOSICOES_SEM_DASHCAM = ['NO_DASHCAM', 'NO_VIDEO_DEVICE'],
      MANUAL_EVENT_HARDWARE_I18N = 'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.manualEventHardware';

  class TiposEventosCtrl {
    constructor($scope, $uibModal, $log, $window, Authenticator, safetyService, Restangular, AlertMessage, AlertasEnum, FeatureFlag,
      Keys, ServiceVfiltro, FactoryVfiltro, $translate, ConfigEventosService, FeatureOuService, FeaturehubJsSdk, FeatureHubConfigKeys, SpeedingBucketService, ConvertersService, EventsToAlerts) {
      this.scope = $scope;
      this.safetyIsCollapsed = false;
      this.inCabIsCollapsed = false;
      this.modalService = $uibModal;
      this.restangular = Restangular;
      this.alertMessage = AlertMessage;
      this.alertasEnum = AlertasEnum;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.translate = $translate;
      this.featureFlag = FeatureFlag;
      this.configEventosService = ConfigEventosService;
      this.authenticator = Authenticator;
      this.featureOuService = FeatureOuService;
      this.removeReadMore = false;
      this.log = $log;
      this.window = $window;
      this.safetyService = safetyService;
      this.speedingBucketService = SpeedingBucketService;
      this.uoId = 0;
      this.roleCadastrar = true;
      this.model = {configuracoes: [], configuracoesSafety: [], configuracoesInCab: [], checkAllAlertas: false, checkAllVideos: false, checkAllAutomatedCoaching: false};
      this.safetyConfigsLength = 0;
      this.speedDescriptionsVia = [];
      this.speedDescriptions = [];
      this.convertersService = ConvertersService;
      this.mapLabel = EventsToAlerts.map(item => Object.assign({}, item, {
        enum: this.alertasEnum[item.enum],
        titulo: this.translate.instant(ROW_TITLES[item.tipo] || item.titulo)
      }));
      this.subItems = ['ultrapassagemIlegal'];
      this.tituloItemsSafety = ['stabilityControl'];
      this.alertsWithSubItem = [
        {name: 'distanciaPerigosa', subItem: 'ultrapassagemIlegal'}
      ];
      this.alertsDisableVideo = ['carona'];
      this.rideSpecificData = [
        {
          label: this.translate.instant(
            'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.ride.xOrMore', {x: 2}
          ),
          value: 2
        },
        {
          label: this.translate.instant(
            'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.ride.xOrMore', {x: 3}
          ),
          value: 3
        }
      ];
      this.alertsWithSpecificData = ['carona'];
      this.featurehubJsSdk = FeaturehubJsSdk;

      this.serviceVfiltro.init(FactoryVfiltro.get([
        {
          key: this.keys.uo.name
        }
      ]))
      .then((filtro) => {
        this.roleCadastrar = this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('CONFIGURACAO_ALERTA_EDITAR');
        this.init(filtro.find(x => x.key === this.keys.uo.name).value.id);
      });
      this.flagCollapseTables = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.COLLAPSIBLE_TABLES);
      this.flagFixUiBehavior = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.FIX_UI_BEHAVIOR);
      this.flagSeparateStabilityControl = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.SEPARATE_STABILITY_CONTROL);
      this.flagRollingStop = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ROLLING_STOP);
      this.flagManualEventHardware = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.MANUAL_EVENT_HARDWARE);
      this.composicaoVideo = null;
      this.mediaTypes = [
        {value: MEDIA_TYPE.VIDEO, label: `${MANUAL_EVENT_HARDWARE_I18N}.tipoMidia.video`},
        {value: MEDIA_TYPE.IMAGE, label: `${MANUAL_EVENT_HARDWARE_I18N}.tipoMidia.imagem`},
        {value: MEDIA_TYPE.NO_MEDIA, label: `${MANUAL_EVENT_HARDWARE_I18N}.tipoMidia.semMidia`}
      ];
    }
    init(uoId) {
      this.uoId = uoId;

      if (this.featurehubJsSdk.isFeatureEnabled('TTLAINT1548_save_and_read_alerts_tag')) {
        this.authenticator.getUser().then(user => {
          this.getEventsConfig(user);
        });
      }

      Promise.all([
        this.restangular.one(`configuracao/configuracoes/${this.uoId}/alerta`).get(),
        this.restangular.one(`sensor/uos/${this.uoId}/configuracoes/eventos`).get(),
        this.configEventosService.getConfigEventos()
      ])
      .then(([alertas, eventos, configEventos]) => {
        this.setConfiguracoesView(alertas, eventos, configEventos);
        this.updateCheckAllAlertas();
        this.updateCheckAllVideos();
        this.updateCheckAllAutomatedCoaching();
      })
      .catch(() => {
        this.alertMessage.create({
          type: 'error',
          message: 'Ocorreu um erro ao carregar as configurações',
          appendTo: '.alerta-aqui-geral'
        });
      });
      this.authenticator.getUser().then(user => {
        this.distanceUnitFormat = user.measurementUnits.distanceMeasurement;
      });
      if (this.flagManualEventHardware) {
        this.getComposicaoVideo();
      }
    }

    getComposicaoVideo() {
      return this.restangular.one('veiculo/module/video-composition').get({uoId: this.uoId})
        .then(response => {
          this.composicaoVideo = response.composition;
        })
        .catch(() => {
          this.composicaoVideo = null;
        });
    }

    setConfiguracoesView(alertas, eventos, configEventos) {
      return this.scope.$apply(() => {
        this.model.configuracoesSafety = this.setConfiguracoes(alertas, eventos, configEventos, SAFETY);
        this.model.configuracoesInCab = this.setConfiguracoes(alertas, eventos, configEventos, IN_CAB);
        this.model.configuracoes = [...this.model.configuracoesInCab, ...this.model.configuracoesSafety];
        if (this.flagFixUiBehavior) {
          this.safetyConfigsLength = this.model.configuracoesSafety.length - this.tituloItemsSafety.length;
        }
      });
    }

    getEventsConfig(user) {
      this.featureOuService.getEventsConfig(user.uo.id).then((eventNaConfig) => {
        this.removeReadMore = eventNaConfig;
        this.showSpeedDescription = eventNaConfig;
        this.getSpeedingLevels(user.uo.id).then(() => {
          this.speedDescriptionsVia = this.getSpeedLevelDescription(null, true);
          this.speedDescriptions = this.getSpeedLevelDescription(null, false);
        });
        if (!eventNaConfig) {
          this.safetyService
            .initialize()
            .then(() => this.loadReact(user));
        }
      });
    }

    loadReact(user) {
      const appName = 'safetyApp',
          componentPath = './AlertsTag',
          componentId = 'safety-alerts-tag',
          props = {
            user: user,
            ouId: this.uoId
          };
      this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
    }

    setConfiguracoes(alertas, eventos, configEventos, category) {
      this.sortMapLabel();
      if (this.flagSeparateStabilityControl && category === SAFETY) {
        this.separateStabilityControl();
      }
      return this.mapLabel
        .filter(alertaMapeado => this.flagRollingStop
          || (alertaMapeado.enum.id !== this.alertasEnum.ROLLING_STOP.id
            && alertaMapeado.enum.id !== this.alertasEnum.NO_STOP.id))
        .filter(alertaMapeado => alertaMapeado.enum.id !== this.alertasEnum.NO_STOP.id)
        .filter(alertaMapeado => this.flagManualEventHardware || alertaMapeado.enum.id !== this.alertasEnum.MANUAL_EVENT_HARDWARE.id)
        .filter(alertaMapeado => !configEventos[alertaMapeado.tipo] || configEventos[alertaMapeado.tipo].enabled !== false)
        .filter(alertaMapeado => alertaMapeado.enum.isEnabled(configEventos))
        .filter(alertaMapeado => alertas.configuracoes[this.alertConfigKey(alertaMapeado.tipo)]
          ? alertas.configuracoes[this.alertConfigKey(alertaMapeado.tipo)].configuracaoVisivel
          : null
        )
        .filter(alertaMapeado => alertaMapeado.enum.category === category)
        .map((item) => {
          if (item) {
            const [alerta, evento] = [alertas.configuracoes[this.alertConfigKey(item.tipo)] || {}, eventos.configuracoes[item.tipo] || {}];
            return {
              item,
              alertaAtivo: !!alerta.ativo,
              eventoAtivo: evento.ativo,
              videoAtivo: !!alerta.videoAtivo,
              automatedCoaching: !!alerta.automatedCoaching,
              specificData: this.getSpecificData(alerta.specificDataHashMap, item.tipo, !!alerta.ativo),
              mediaType: this.getMediaType(alerta, item)
            };
          }
        });
    }

    getMediaType(alerta, item) {
      if (!this.isManualEventHardware(item)) {
        return undefined;
      }
      if (alerta.mediaType) {
        return alerta.mediaType;
      }
      return alerta.videoAtivo ? MEDIA_TYPE.VIDEO : MEDIA_TYPE.NO_MEDIA;
    }

    isManualEventHardware(item) {
      return item.tipo === MANUAL_EVENT_HARDWARE;
    }

    isDashcamNecessaria(item) {
      return this.isManualEventHardware(item) && COMPOSICOES_SEM_DASHCAM.includes(this.composicaoVideo);
    }

    isFrotaMista(item) {
      return this.isManualEventHardware(item) && this.composicaoVideo === 'MIXED';
    }

    changeMediaType(config) {
      config.videoAtivo = config.mediaType === MEDIA_TYPE.VIDEO;
      this.updateCheckAllVideos();
    }

    getSpecificData(specificDataHashMap, eventType, active) {
      switch (eventType) {
        case 'carona':
          const value = specificDataHashMap && specificDataHashMap.peopleCount;
          return angular.isDefined(value) && active ? value : null;
        default:
          return null;
      }
    }

    sortMapLabel() {
      this.mapLabel.sort((a, b) => a.titulo.localeCompare(b.titulo));
      this.alertsWithSubItem.forEach((item) => {
        let indexItem, indexSubItem;
        indexItem = this.mapLabel.findIndex((alerta) => alerta.tipo === item.name);
        indexSubItem = this.mapLabel.findIndex((alerta) => alerta.tipo === item.subItem);

        if (indexItem !== -1 && indexSubItem !== -1) {
          const [subItem] = this.mapLabel.splice(indexSubItem, 1);
          this.mapLabel.splice(indexItem + 1, 0, subItem);
        }
      });
      return this.mapLabel;
    }

    separateStabilityControl() {
      let indexStabilityControl;
      indexStabilityControl = this.mapLabel.findIndex(label => label.tipo === STABILITY_CONTROL);
      if (indexStabilityControl === -1) {
        return;
      }

      this.subItems.push(...STABILITY_CONTROL_SUB_ITEMS);
      this.groupStabilityControlSubItems();
    }

    groupStabilityControlSubItems() {
      const subItems = STABILITY_CONTROL_SUB_ITEMS
        .map(tipo => this.mapLabel.find(label => label.tipo === tipo))
        .filter(subItem => !!subItem);

      subItems.forEach(subItem => this.mapLabel.splice(this.mapLabel.indexOf(subItem), 1));

      // o indice do pai precisa ser lido depois da remocao dos sub itens, senao fica defasado
      this.mapLabel.splice(this.mapLabel.findIndex(label => label.tipo === STABILITY_CONTROL) + 1, 0, ...subItems);
    }

    alertConfigKey(tipo) {
      return ALERT_CONFIG_KEYS[tipo] || tipo;
    }

    configuracoesToObject() {
      if (this.flagSeparateStabilityControl) {
        const indexStabilityControl = this.model.configuracoes.findIndex(config => config.item.tipo === STABILITY_CONTROL);
        if (indexStabilityControl !== -1) {
          this.model.configuracoes.splice(indexStabilityControl, 1);
        }
      }
      return this.model.configuracoes.reduce(({accAlertas, accEventos}, config) => {
        let specificData = null;
        if (this.alertsWithSpecificData.includes(config.item.tipo)) {
          specificData = this.handleSpecificData(config.item.tipo, config.specificData);
        }
        accAlertas[this.alertConfigKey(config.item.tipo)] = {
          ativo: !!config.alertaAtivo,
          videoAtivo: !!config.videoAtivo,
          automatedCoaching: !!config.alertaAtivo && !!config.automatedCoaching,
          specificDataHashMap: config.alertaAtivo ? specificData : null
        };
        if (config.mediaType) {
          accAlertas[this.alertConfigKey(config.item.tipo)].mediaType = config.mediaType;
        }
        if (angular.isDefined(config.eventoAtivo)) {
          accEventos[config.item.tipo] = {ativo: !!config.eventoAtivo};
        }
        return {accAlertas, accEventos};
      }, {accAlertas: {}, accEventos: {}});
    }

    handleSpecificData(eventType, value) {
      switch (eventType) {
        case 'carona':
          return {peopleCount: value};
        default:
          return null;
      }
    }

    getEventTooltip(item) {
      return item.enum && item.enum.tooltip ? this.translate.instant(item.enum.tooltip) : null;
    }

    isEventTooltip(item) {
      return !!item.enum.tooltip;
    }

    isSpeedLimitVia(item) {
      return item.tipo === 'speedlimitVia';
    }

    isSpeedLimit(item) {
      return item.tipo === 'speedlimit';
    }

    isPossivelColisao(item) {
      return item.tipo === 'possivelColisao';
    }

    isEPIEvent(item) {
      return item.tipo === 'semCone' || item.tipo === 'semOculos' || item.tipo === 'semLuvas';
    }

    isIlegalOvertaking(item) {
      return item.tipo === 'ultrapassagemIlegal';
    }

    isRideEvent(item) {
      return item.tipo === 'carona';
    }

    isFuncionalidadeExperimental(item) {
      return this.isEPIEvent(item) ||
        this.isPossivelColisao(item) ||
        this.isIlegalOvertaking(item) ||
        this.isRideEvent(item);
    }

    isSubItem(item) {
      return this.subItems.indexOf(item.tipo) > -1;
    }

    checkAlerta(alertConfig) {
      this.updateCheckAllAlertas();
      this.updateCheckAllVideos();

      const matchedItem = this.alertsWithSubItem.find((alert) => alert.name === alertConfig.item.tipo);

      if (angular.isDefined(alertConfig.eventoAtivo) && alertConfig.alertaAtivo) {
        alertConfig.eventoAtivo = true;
      }

      if (!alertConfig.alertaAtivo) {
        alertConfig.videoAtivo = false;
        alertConfig.automatedCoaching = false;
      } else if (alertConfig.mediaType) {
        alertConfig.videoAtivo = alertConfig.mediaType === MEDIA_TYPE.VIDEO;
      }

      if (matchedItem) {
        const subItem = this.model.configuracoes.find((config) => config.item.tipo === matchedItem.subItem);
        this.handleSubItemConfig(subItem, alertConfig.alertaAtivo);
      }

      this.updateCheckAllAutomatedCoaching();
    }

    updateCheckAllAlertas() {
      if (!this.flagFixUiBehavior) {
        return;
      }
      this.model.checkAllAlertas = this.model.configuracoes.length > 0 && this.model.configuracoes.every((config) => config.alertaAtivo || this.tituloItemsSafety.includes(config.item.tipo) || this.isDashcamNecessaria(config.item));
    }

    updateCheckAllVideos() {
      if (!this.flagFixUiBehavior) {
        return;
      }
      this.model.checkAllVideos = this.model.checkAllAlertas && this.model.configuracoes.length > 0 && this.model.configuracoes.every((config) => config.videoAtivo || this.tituloItemsSafety.includes(config.item.tipo) || this.isManualEventHardware(config.item));
    }

    handleSubItemConfig(subItem, isAlertaAtivo) {
      if (!subItem) {
        return;
      }

      if (!isAlertaAtivo) {
        Object.assign(subItem, {alertaAtivo: false, isDisabled: true});
        subItem.automatedCoaching = false;
      } else {
        subItem.isDisabled = false;
      }
    }

    checkSubItemConfig(configSubItem) {
      this.updateCheckAllAlertas();
      if (!configSubItem.alertaAtivo) {
        configSubItem.videoAtivo = false;
        configSubItem.automatedCoaching = false;
      }
      this.updateCheckAllAutomatedCoaching();
    }

    checkFirst(isFirst, config, value) {
      if (isFirst && config.specificData === null) {
        config.specificData = value;
      }
      return angular.isDefined(config.specificData) && config.specificData === value;
    }

    checkAllAlertas() {
      this.model.configuracoes
        .filter((config) => !this.isDashcamNecessaria(config.item))
        .forEach((config) => config.alertaAtivo = this.model.checkAllAlertas);
      if (!this.model.checkAllAlertas) {
        this.model.checkAllVideos = false;
        this.model.configuracoes.forEach((config) => {
          config.videoAtivo = this.model.checkAllVideos;
          config.automatedCoaching = false;
        });
        this.model.checkAllAutomatedCoaching = false;
      }
    }

    checkAllVideos() {
      this.model.configuracoes.forEach((config) => {
        if (config.alertaAtivo && !this.disableVideo(config.item.tipo) && !this.isManualEventHardware(config.item)) {
          config.videoAtivo = this.model.checkAllVideos;
        }
      });
    }

    checkAllAutomatedCoaching() {
      this.model.configuracoes.forEach((config) => {
        if (config.alertaAtivo) {
          config.automatedCoaching = this.model.checkAllAutomatedCoaching;
        }
      });
    }

    updateCheckAllAutomatedCoaching() {
      if (!this.flagFixUiBehavior) {
        return;
      }
      this.model.checkAllAutomatedCoaching = this.model.configuracoes.length > 0 && this.model.configuracoes.every((config) =>
        (config.alertaAtivo && config.automatedCoaching) || this.tituloItemsSafety.includes(config.item.tipo));
    }

    disableVideo(type) {
      return this.alertsDisableVideo.includes(type);
    }

    abrirModal() {
      this.modalService.open({
        animation: true,
        templateUrl: 'configuracoes/eventos/modal/info/info-eventos.tpl.html',
        controller: 'ModalInfoEventosCtrl',
        controllerAs: '$ctrl',
        size: 'lg'
      });
    }

    salvar() {
      const configs = this.configuracoesToObject(),
          configAlertas = {
            uoId: this.uoId,
            configuracoes: configs.accAlertas
          },
          configEventos = {
            uo: {id: this.uoId},
            configuracoes: configs.accEventos
          };

      this.mapLabel.forEach(label => {
        if (this.flagSeparateStabilityControl && this.tituloItemsSafety.includes(label.tipo)) {
          return;
        }
        if (!configAlertas.configuracoes[this.alertConfigKey(label.tipo)]) {
          configAlertas.configuracoes[this.alertConfigKey(label.tipo)] = {
            ativo: false,
            videoAtivo: false,
            automatedCoaching: false
          };
        }
      });

      this.mapLabel.forEach(label => {
        if (this.flagSeparateStabilityControl && this.tituloItemsSafety.includes(label.tipo)) {
          return;
        }
        if (!configAlertas.configuracoes[this.alertConfigKey(label.tipo)]) {
          configAlertas.configuracoes[this.alertConfigKey(label.tipo)] = {
            ativo: false,
            videoAtivo: false,
            automatedCoaching: false
          };
        }
      });

      Promise.all([
        this.restangular.all(`configuracao/configuracoes/${this.uoId}/alerta`).customPUT(configAlertas),
        this.restangular.all(`sensor/uos/${this.uoId}/configuracoes/eventos`).post(configEventos)
      ]).then(() => {
        this.scope.formAlertas.$setPristine();
        this.scope.$apply(() => {
          this.alertMessage.create({
            type: 'success',
            message: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.sucessoMsg'),
            appendTo: '.alerta-aqui'
          });
        });
      })
      .catch(() => {
        this.scope.$apply(() => {
          this.alertMessage.create({
            type: 'error',
            message: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.erro'),
            appendTo: '.alerta-aqui'
          });
        });
      });
    }

    unmountReactComponent() {
      if (this.window.ReactDOM && this.container) {
        if (this.window.ReactDOM.unmountComponentAtNode(this.container)) {
          this.log.log('React component unmounted');
        } else {
          this.log.log('React component was not mounted.');
        }
      } else {
        this.log.log('Container not found or React component was not mounted.');
      }
    }

    collapse(category) {
      if (category === SAFETY) {
        this.safetyIsCollapsed = !this.safetyIsCollapsed;
      } else if (category === 'inCab') {
        this.inCabIsCollapsed = !this.inCabIsCollapsed;
      }
    }

    getCaronaTooltip(x) {
      return this.translate.instant('ce.enum.eventosTooltips.carona', {x});
    }

    getSpeedLevelDescription(level, isSpeedLimitVia = false) {
      if (!this.speedingLevels) {
        return [];
      }
      const descriptions = [],
          shouldConvert = isSpeedLimitVia && this.distanceUnitFormat === 'MILES',
          level1Min = (shouldConvert ? this.convertersService.handleKmToMiles(this.speedingLevels.speedingBucketKmh1min) : this.speedingLevels.speedingBucketKmh1min) || 6,
          level1Max = (shouldConvert ? this.convertersService.handleKmToMiles(this.speedingLevels.speedingBucketKmh1max) : this.speedingLevels.speedingBucketKmh1max) || 17,
          level2Min = (shouldConvert ? this.convertersService.handleKmToMiles(this.speedingLevels.speedingBucketKmh2min) : this.speedingLevels.speedingBucketKmh2min) || 19,
          level2Max = (shouldConvert ? this.convertersService.handleKmToMiles(this.speedingLevels.speedingBucketKmh2max) : this.speedingLevels.speedingBucketKmh2max) || 24,
          level3Min = (shouldConvert ? this.convertersService.handleKmToMiles(this.speedingLevels.speedingBucketKmh3min) : this.speedingLevels.speedingBucketKmh3min) || 25;

      if (isSpeedLimitVia) {
        descriptions.push({
          color: 'blue',
          text: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.level1', {
            kmh1Min: level1Min,
            kmh1Max: level1Max
          })
        });

        descriptions.push({
          color: 'yellow',
          text: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.level2', {
            kmh2Min: level2Min,
            kmh2Max: level2Max
          })
        });

        descriptions.push({
          color: 'red',
          text: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.level3', {
            kmh3Min: level3Min
          })
        });
      } else {
        descriptions.push({
          color: 'blue',
          text: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidade.level1', {
          })
        });

        descriptions.push({
          color: 'yellow',
          text: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidade.level2', {
          })
        });

        descriptions.push({
          color: 'red',
          text: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidade.level3', {
          })
        });
      }

      if (level && level >= 1 && level <= 3) {
        return [descriptions[level - 1]];
      }

      return descriptions;
    }

    getSpeedingLevels(uoId) {
      return this.speedingBucketService.getSpeedingBucketsPorUo(uoId).then((speedingLevels) => {
        this.speedingLevels = speedingLevels;
      });
    }
    getSpeedLimitViaDescriptions() {
      return this.getSpeedLevelDescription(null, true);
    }
    getSpeedLimitDescriptions() {
      return this.getSpeedLevelDescription(null, false);
    }
  }

  angular
    .module('SubpaginasEventos')
    .controller('TiposEventosCtrl', TiposEventosCtrl);
}());
